export type SiteSeoConfig = {
  title: string;
  description: string;
  label: string;
  indexable?: boolean;
};

/** Canonical metadata for static pages. Article metadata remains in shared/blogPosts.ts. */
export const siteSeoRoutes: Record<string, SiteSeoConfig> = {
  "/": {
    title: "Aventura Title & Escrow Services | Premier Title Solutions",
    description: "Premier Title Solutions provides title insurance and escrow services for residential and commercial real estate closings in Aventura and across South Florida.",
    label: "Title & Escrow Services",
  },
  "/about-us": {
    title: "About Our Aventura Title Company | Premier Title Solutions",
    description: "Learn about Premier Title Solutions, an Aventura title insurance and escrow firm focused on precise, compliant closing services for Florida transactions.",
    label: "About Us",
  },
  "/services": {
    title: "Florida Title & Escrow Services | Premier Title Solutions",
    description: "Explore residential and commercial closings, title insurance, and escrow services from Premier Title Solutions for real estate transactions throughout Florida.",
    label: "Services",
  },
  "/contact-us": {
    title: "Contact Our Aventura Title Team | Premier Title Solutions",
    description: "Contact Premier Title Solutions for title insurance, escrow, closing coordination, and secure real estate transaction support for your Florida closing.",
    label: "Contact",
  },
  "/title-quote": {
    title: "Florida Title & Closing Cost Quote | Premier Title Solutions",
    description: "Request a title insurance and closing cost quote from Premier Title Solutions for a residential or commercial real estate transaction in Aventura or Florida.",
    label: "Request a Quote",
  },
  "/open-a-file": {
    title: "Open a Florida Title File | Premier Title Solutions",
    description: "Open a secure title and escrow file with Premier Title Solutions by selecting the intake form for your role and Florida real estate transaction.",
    label: "Open a File",
  },
  "/open-a-file/listing-agent": {
    title: "Open a Listing Agent File | Premier Title Solutions",
    description: "Open a title and escrow file for your seller's listing with Premier Title Solutions and share the property, seller, and closing details needed to begin.",
    label: "Listing Agent File",
  },
  "/open-a-file/buyers-agent": {
    title: "Open a Buyer's Agent File | Premier Title Solutions",
    description: "Open a title and escrow file for your buyer's purchase with Premier Title Solutions and share the property, buyer, contract, and closing details needed.",
    label: "Buyer's Agent File",
  },
  "/open-a-file/others": {
    title: "Open an Other Title File | Premier Title Solutions",
    description: "Open a title and escrow file for a loan, refinance, or other professional transaction with Premier Title Solutions and share the details needed to begin.",
    label: "Other File",
  },
  "/open-a-file/consumer": {
    title: "Open a Buyer or Seller File | Premier Title Solutions",
    description: "Open a title and escrow file with Premier Title Solutions as a buyer or seller and share the property, contract, and closing details needed to begin.",
    label: "Buyer or Seller File",
  },
  "/faq": {
    title: "Florida Title & Escrow FAQs | Premier Title Solutions",
    description: "Get answers about opening a file, title insurance, closing costs, escrow services, wire fraud, and the Florida real estate closing process with our team.",
    label: "FAQs",
  },
  "/blog": {
    title: "Florida Title & Escrow Insights | Premier Title Solutions",
    description: "Read practical guidance for buyers, sellers, agents, and lenders about title insurance, escrow, wire safety, and details that affect a Florida closing.",
    label: "Blog",
  },
  "/privacy-policy": {
    title: "Premier Title Solutions Privacy Policy",
    description: "How Premier Title Solutions collects, uses, shares, and protects information in connection with title insurance, escrow, and closing services in Florida.",
    label: "Privacy Policy",
    indexable: false,
  },
  "/terms-of-use": {
    title: "Premier Title Solutions Terms of Use",
    description: "Terms governing use of the Premier Title Solutions website, including important information about wire fraud, quotes, and title insurance.",
    label: "Terms of Use",
    indexable: false,
  },
  "/thank-you": {
    title: "Thank You From Premier Title Solutions",
    description: "Premier Title Solutions has received your request and will follow up with the next steps for your closing inquiry.",
    label: "Thank You",
    indexable: false,
  },
  "/title-quote/thank-you": {
    title: "Thank You From Premier Title Solutions",
    description: "Premier Title Solutions has received your title quote request and will follow up with the next steps.",
    label: "Thank You",
    indexable: false,
  },
};

export function normalizeSitePath(pathname: string) {
  const withoutTrailingSlash = pathname.replace(/\/+$/, "");
  return withoutTrailingSlash || "/";
}
